<template>
	<page>
		<module enable-flex :tabs="tabs" @tabChange="tabHandle">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="商品标题">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="订单编号">
					<c-input name="order_number"></c-input>
				</m-search-item>
                <m-search-item label="收货信息">
                    <c-input name="receiving_info"></c-input>
                </m-search-item>
				<m-search-item label="下单时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>
            </m-operate>
			<c-table ref="table" height="grow">
				<c-table-column
					width="400"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="数量"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="总金额"
					width="170"
					align-center
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					width="170"
					align-center
				></c-table-column>

				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<!-- <c-checkbox></c-checkbox> -->
								<span class="number">订单号：{{data.order_number}}</span>
                                <div class="tag" style="background:brown">供货</div>
								<p class="info">下单时间：{{data.create_date}}</p>
							</div>
						</div>
                        <div class="order-head flex-between-center">
                            <div class="flex-center">
								<span class="number">
									收货信息：{{data.receiving_name}}；{{data.receiving_phone}}；{{data.receiving_address}}
								</span>
                            </div>
                        </div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
											<p class="sku-sku">{{sku.product_sku_spec}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
								</div>
							</div>
							<div class="order-sum flex-column flex-center">
								<span>
									￥{{data.product_money}}
								</span>
							</div>
							<div class="order-state flex-column flex-center">
								<span>{{orderStateName[data.order_state]}}</span>
								<span v-if="data.order_state == 3">({{data.deliver_state}})</span>
								<a @click="navigateTo(`/order_detail/${data.order_number}`)">订单详情</a>
							</div>
						</div>
					</div>
				</template>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from "@/components/public/product_info.vue";
	
	export default {
		components: {productInfo},
		props: {
			tab: String
		},
		
		data() {
			return {
                workType:23,
                searchParams:{},
				tabsData: [{
					name: '全部订单'
				}, {
					name: '待发货',
					param: {
						order_state: [2]
					}
				}, {
					name: '已发货',
					param: {
						order_state: [3]
					}
				}, {
                    name: '已收货',
                    param: {
                        order_state: [5]
                    }
                }],
				tabsTotal: [],
				currentTab: {},
				orderStateName: {
					2: '待发货',
					3: '待收货',
					5: '已收货'
				},
				trandferList: [],
				trandferNum: {},
				orderNumber:''
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			tabs() {
				return Array.from(this.tabsData, (item, index) => {
					return Object.assign({}, item, {
						name: this.tabsTotal[index] > 0 ? `${item.name}(${this.tabsTotal[index]})` : item.name
					});
				});
			}
		},
		
		mounted() {
			this.updateTotal();
		},
		
		methods: {
			tabHandle(item) {
				this.currentTab = item;
				this.$refs.search.search();
			},
			
			updateTotal() {
				this.request({
					url: '/purchase/order/state/count_list',
					success: data => {
						this.tabsTotal = data;
					}
				});
			},
			
			searchHandle(data) {
                this.searchParams = Object.assign(data, this.currentTab.param);
                this.$refs.table.load({
					url: '/purchase/order/detail_list',
					data: this.searchParams
				});
                this.updateTotal();
			},
            /**同步导出数据**/
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		box-sizing: border-box;
		min-width: 1170px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.tag {
				border-radius: 2px;
				padding: 0 5px;
				margin-left: 6px;
				line-height: 18px;
				color: #fff;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 660;
			flex-basis: 660px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 400;
					flex-basis: 400px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 170;
			flex-basis: 170px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
